import React, { useEffect }  from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { BuildingProvider } from "./components/contexts/BuildingContext";
import { Login, Signup } from "./components/loginPages";
import { BuildingList, BuildingDetail } from "./components/buildingPages";
import { Bill, Electricity, Water } from './components/billingPages';
import "./App.css";
import { RoomProvider } from "./components/contexts/RoomContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminPage from "./components/adminPages/AdminPage";

import { MobileHome } from "./components/mobilePages";
import { isMobile } from "react-device-detect";

const App = () => {
  const role = sessionStorage.getItem("role");
  const navigate = useNavigate();

  useEffect(() => {
    if (isMobile) {
      navigate("/mobile-home");
    }
  }, [navigate]); 

  return (
      <BuildingProvider>
        <RoomProvider>
          <div className="main-content">
            <Routes>
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />

              {/* 일반 사용자 경로 */}
              <Route path="/mobile-home" element={<MobileHome />} />
              <Route path="/building-list" element={<BuildingList />} />
              <Route path="/building-detail/:id" element={<BuildingDetail />} />
              <Route path="/electricity" element={<Electricity />} />
              <Route path="/water" element={<Water />} />
              <Route path="/bill" element={<Bill />} />

              {/* 어드민 전용 경로 */}
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute>
                    <AdminPage />
                  </ProtectedRoute>
                } 
              />

              {/* 기본 경로 처리 */}
              <Route 
                path="/" 
                element={<Navigate to={role ? (role === "ADMIN" ? "/admin" : "/building-list") : "/building-list"} replace />}
              />
            </Routes>
          </div>
        </RoomProvider>
      </BuildingProvider>
  );
};

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;